import React, { useState } from "react";
import ChevronDownIcon from "../../../assets/icons/chevronDownIcon.svg";
import { isMobile } from "react-device-detect";

interface MenuComponentProps {
  menuTitle: string;
  isToggleMenuManually?: boolean;
  menuList: JSX.Element;
}

const MenuComponent: React.FC<MenuComponentProps> = ({
  menuTitle,
  isToggleMenuManually = true,
  menuList,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMouseEnter = () => {
    setIsOpen(true);
  };

  const handleMouseLeave = () => {
    setIsOpen(false);
  };

  const handleOnClickToggle = () => {
    if (isMobile) {
      toggleMenu();
    } else {
      // If not mobile and user wants to open menu on click
      if (isToggleMenuManually) {
        toggleMenu();
      }
    }
  };

  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => !isToggleMenuManually && handleMouseEnter()}
      onMouseLeave={() => !isToggleMenuManually && handleMouseLeave()}
    >
      <div className={`flex items-center justify-between w-full rounded-md text-white px-1.5 text-sm  bg-[#243A48]`}>
        <span className="text-md font-medium p-1">{menuTitle}</span>
        <button
          onClick={handleOnClickToggle}
          className="flex items-center gap-2"
        >
          <img
            src={ChevronDownIcon}
            alt="chevron-down"
            className="w-3 h-3" // Adjust size if needed
          />
        </button>
      </div>

      {isOpen && (
        <div
          className="bg-white h-auto w-44 z-50 absolute top-10 origin-top-right right-0 rounded-md border border-gray-300"
          style={{ boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.1)" }}
        >
          {menuList}
        </div>
      )}

    </div>
  );

};

export default MenuComponent;
